import { InjectionToken, Injectable, Inject, Directive, ViewContainerRef, TemplateRef, Input, NgModule, Optional, defineInjectable, inject } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { CookiesService } from '@ngx-utils/cookies';
import { CookiesService as CookiesService$1 } from '@ngx-utils/cookies/src/cookies.service';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} msg
 * @return {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-utils/cookies';
function error(msg) {
    throw ('AngularAbTests error: ' + msg);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AbTestForRealUser {
    /**
     * @param {?} versions
     * @param {?} chosenVersion
     */
    constructor(versions, chosenVersion) {
        this._versions = [];
        this._versions = versions;
        this._chosenVersion = chosenVersion;
    }
    /**
     * @return {?}
     */
    getVersion() {
        return this._chosenVersion;
    }
    /**
     * @param {?} version
     * @return {?}
     */
    setVersion(version) {
        if (this._versions.indexOf(version) === -1) {
            error('Version <' + version + '> has not been declared: [ ' + this._versions.join(', ') + ' ]');
        }
        this._chosenVersion = version;
    }
    /**
     * @param {?} versions
     * @param {?} forCrawlers
     * @return {?}
     */
    shouldRender(versions, forCrawlers) {
        for (let /** @type {?} */ version of versions) {
            if (this._versions.indexOf(version) === -1) {
                error('Version <' + version + '> has not been declared: [ ' + this._versions.join(', ') + ' ]');
            }
        }
        return (versions.indexOf(this._chosenVersion) !== -1);
    }
}
class AbTestForCrawler {
    /**
     * @param {?=} version
     */
    constructor(version) {
        if (!!version) {
            this._version = version;
        }
    }
    /**
     * @return {?}
     */
    getVersion() {
        return '';
    }
    /**
     * @param {?} version
     * @return {?}
     */
    setVersion(version) { }
    /**
     * @param {?} versions
     * @param {?} forCrawlers
     * @return {?}
     */
    shouldRender(versions, forCrawlers) {
        return forCrawlers || (!!this._version && versions.indexOf(this._version) !== -1);
    }
}
class RandomExtractor {
    /**
     * @param {?} weights
     * @return {?}
     */
    setWeights(weights) {
        this._weights = weights;
    }
    /**
     * @param {?} versions
     * @return {?}
     */
    setVersions(versions) {
        this._versions = versions;
    }
    /**
     * @return {?}
     */
    run() {
        if (this._weights.length === 0) {
            return this._versions[Math.floor(Math.random() * this._versions.length)];
        }
        let /** @type {?} */ random = Math.random() * 100;
        for (let /** @type {?} */ weight of this._weights) {
            if (random <= weight[0]) {
                return weight[1];
            }
        }
        return this._versions[0];
    }
}
/**
 * @abstract
 */
class AbstractUserAgentCrawlerDetector {
    constructor() {
        this._regexps = [
            /bot/i, /spider/i, /facebookexternalhit/i, /simplepie/i, /yahooseeker/i, /embedly/i,
            /quora link preview/i, /outbrain/i, /vkshare/i, /monit/i, /Pingability/i, /Monitoring/i,
            /WinHttpRequest/i, /Apache-HttpClient/i, /getprismatic.com/i, /python-requests/i, /Twurly/i,
            /yandex/i, /browserproxy/i, /Monitoring/i, /crawler/i, /Qwantify/i, /Yahoo! Slurp/i, /pinterest/i
        ];
    }
    /**
     * @return {?}
     */
    isCrawler() {
        return this._regexps.some((crawler) => {
            return crawler.test(this.getUserAgentString());
        });
    }
}
class CrawlerDetector extends AbstractUserAgentCrawlerDetector {
    /**
     * @return {?}
     */
    getUserAgentString() {
        return window.navigator.userAgent;
    }
}
class CookieHandler {
    /**
     * @param {?} name
     * @return {?}
     */
    get(name) {
        name = encodeURIComponent(name);
        let /** @type {?} */ regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        let /** @type {?} */ results = regexp.exec(document.cookie);
        return (!results) ? '' : decodeURIComponent(results[1]);
    }
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} domain
     * @param {?=} expires
     * @return {?}
     */
    set(name, value, domain, expires) {
        let /** @type {?} */ cookieStr = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
        if (expires) {
            let /** @type {?} */ dtExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
            cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
        }
        if (domain) {
            cookieStr += 'domain=' + domain + ';';
        }
        document.cookie = cookieStr;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ CONFIG = new InjectionToken('ANGULAR_AB_TEST_CONFIG');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ COOKIE_NAMESPACE = 'angular-ab-tests';
class AbTestsService {
    /**
     * @param {?} configs
     * @param {?} cookieHandler
     * @param {?} crawlerDetector
     * @param {?} randomExtractor
     */
    constructor(configs, cookieHandler, crawlerDetector, randomExtractor) {
        this._tests = {};
        this._defaultScope = 'default';
        this._cookieHandler = cookieHandler;
        this._randomExtractor = randomExtractor;
        var /** @type {?} */ isCrawler = crawlerDetector.isCrawler();
        for (let /** @type {?} */ config of configs) {
            let /** @type {?} */ scope = this._defaultScope;
            if (!!config.scope) {
                scope = config.scope;
            }
            if (!!this._tests[scope]) {
                error('Test with scope <' + scope + '> cannot be initialized twice');
            }
            if (isCrawler) {
                this.setupTestForCrawler(scope, this.filterVersions(config.versions), config);
            }
            else {
                this.setupTestForRealUser(scope, this.filterVersions(config.versions), config);
            }
        }
    }
    /**
     * @param {?=} scope
     * @return {?}
     */
    getVersion(scope) {
        return this.getTest(scope).getVersion();
    }
    /**
     * @param {?} version
     * @param {?=} scope
     * @return {?}
     */
    setVersion(version, scope) {
        return this.getTest(scope).setVersion(version);
    }
    /**
     * @param {?} versions
     * @param {?} scope
     * @param {?} forCrawlers
     * @return {?}
     */
    shouldRender(versions, scope, forCrawlers) {
        return this.getTest(scope).shouldRender(versions, forCrawlers);
    }
    /**
     * @param {?=} scope
     * @return {?}
     */
    getTest(scope) {
        let /** @type {?} */ scopeOrDefault = scope || this._defaultScope;
        if (!this._tests[scopeOrDefault]) {
            error('Test with scope <' + scopeOrDefault + '> has not been defined');
        }
        return this._tests[scopeOrDefault];
    }
    /**
     * @param {?} versions
     * @return {?}
     */
    filterVersions(versions) {
        let /** @type {?} */ resp = [];
        if (versions.length < 2) {
            error('You have to provide at least two versions');
        }
        for (let /** @type {?} */ version of versions) {
            if (resp.indexOf(version) !== -1) {
                error('Version <' + version + '> is repeated in the array of versions [ ' + versions.join(', ') + ' ]');
            }
            resp.push(version);
        }
        return resp;
    }
    /**
     * @param {?} scope
     * @param {?} versions
     * @param {?} config
     * @return {?}
     */
    setupTestForCrawler(scope, versions, config) {
        if (!!config.versionForCrawlers && versions.indexOf(config.versionForCrawlers) === -1) {
            error('Version for crawlers <' + config.versionForCrawlers + '> is not included in versions [ ' + versions.join(', ') + ' ]');
        }
        this._tests[scope] = new AbTestForCrawler(config.versionForCrawlers);
    }
    /**
     * @param {?} scope
     * @param {?} versions
     * @param {?} config
     * @return {?}
     */
    setupTestForRealUser(scope, versions, config) {
        let /** @type {?} */ chosenVersion = this.generateVersion({
            versions: versions,
            cookieName: COOKIE_NAMESPACE + '-' + scope,
            domain: config.domain,
            expiration: config.expiration,
            weights: config.weights,
        });
        this._tests[scope] = new AbTestForRealUser(versions, chosenVersion);
    }
    /**
     * @param {?} config
     * @return {?}
     */
    generateVersion(config) {
        let /** @type {?} */ chosenVersion = this._cookieHandler.get(config.cookieName);
        if (config.versions.indexOf(chosenVersion) !== -1) {
            return chosenVersion;
        }
        this._randomExtractor.setWeights(this.processWeights(config.weights || {}, config.versions));
        this._randomExtractor.setVersions(config.versions);
        chosenVersion = this._randomExtractor.run();
        this._cookieHandler.set(config.cookieName, chosenVersion, config.domain, config.expiration);
        return chosenVersion;
    }
    /**
     * @param {?} weights
     * @param {?} versions
     * @return {?}
     */
    processWeights(weights, versions) {
        let /** @type {?} */ processedWeights = [];
        let /** @type {?} */ totalWeight = 0;
        let /** @type {?} */ tempVersions = versions.slice(0);
        let /** @type {?} */ index = -100;
        for (let /** @type {?} */ key in weights) {
            index = tempVersions.indexOf(key);
            if (index === -1) {
                error('Weight associated to <' + key + '> which is not included in versions [ ' + versions.join(', ') + ' ]');
            }
            tempVersions.splice(index, 1);
            totalWeight += this.roundFloat(weights[key]);
            processedWeights.push([totalWeight, key]);
        }
        if (index === -100) {
            return [];
        }
        if (totalWeight >= 100) {
            error('Sum of weights is <' + totalWeight + '>, while it should be less than 100');
        }
        let /** @type {?} */ remainingWeight = this.roundFloat((100 - totalWeight) / tempVersions.length);
        for (let /** @type {?} */ version of tempVersions) {
            totalWeight += remainingWeight;
            processedWeights.push([totalWeight, version]);
        }
        processedWeights[processedWeights.length - 1] = [100, processedWeights[processedWeights.length - 1][1]];
        return processedWeights;
    }
    /**
     * @param {?} x
     * @return {?}
     */
    roundFloat(x) {
        return Math.round(x * 1000) / 1000;
    }
}
AbTestsService.ɵfac = function AbTestsService_Factory(t) { return new (t || AbTestsService)(ɵngcc0.ɵɵinject(CONFIG), ɵngcc0.ɵɵinject(CookieHandler), ɵngcc0.ɵɵinject(CrawlerDetector), ɵngcc0.ɵɵinject(RandomExtractor)); };
AbTestsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AbTestsService, factory: AbTestsService.ɵfac });
/** @nocollapse */
AbTestsService.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [CONFIG,] },] },
    { type: CookieHandler, },
    { type: CrawlerDetector, },
    { type: RandomExtractor, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbTestsService, [{
        type: Injectable
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [CONFIG]
            }] }, { type: CookieHandler }, { type: CrawlerDetector }, { type: RandomExtractor }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AbTestVersionDirective {
    /**
     * @param {?} _service
     * @param {?} _viewContainer
     * @param {?} _templateRef
     */
    constructor(_service, _viewContainer, _templateRef) {
        this._service = _service;
        this._viewContainer = _viewContainer;
        this._templateRef = _templateRef;
        this._forCrawlers = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this._service.shouldRender(this._versions, this._scope, this._forCrawlers)) {
            this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set abTestVersion(value) {
        this._versions = value.split(',');
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set abTestVersionScope(value) {
        this._scope = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set abTestVersionForCrawlers(value) {
        this._forCrawlers = value;
    }
}
AbTestVersionDirective.ɵfac = function AbTestVersionDirective_Factory(t) { return new (t || AbTestVersionDirective)(ɵngcc0.ɵɵdirectiveInject(AbTestsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
AbTestVersionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AbTestVersionDirective, selectors: [["", "abTestVersion", ""]], inputs: { abTestVersion: "abTestVersion", abTestVersionScope: "abTestVersionScope", abTestVersionForCrawlers: "abTestVersionForCrawlers" } });
/** @nocollapse */
AbTestVersionDirective.ctorParameters = () => [
    { type: AbTestsService, },
    { type: ViewContainerRef, },
    { type: TemplateRef, },
];
AbTestVersionDirective.propDecorators = {
    "abTestVersion": [{ type: Input },],
    "abTestVersionScope": [{ type: Input },],
    "abTestVersionForCrawlers": [{ type: Input },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbTestVersionDirective, [{
        type: Directive,
        args: [{
                selector: '[abTestVersion]'
            }]
    }], function () { return [{ type: AbTestsService }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }]; }, { abTestVersion: [{
            type: Input
        }], abTestVersionScope: [{
            type: Input
        }], abTestVersionForCrawlers: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AbTestsModule {
    /**
     * @param {?} configs
     * @return {?}
     */
    static forRoot(configs) {
        return {
            ngModule: AbTestsModule,
            providers: [
                AbTestsService,
                { provide: CONFIG, useValue: configs },
                CookieHandler,
                CrawlerDetector,
                RandomExtractor,
            ],
        };
    }
}
AbTestsModule.ɵfac = function AbTestsModule_Factory(t) { return new (t || AbTestsModule)(); };
AbTestsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AbTestsModule });
AbTestsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbTestsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AbTestVersionDirective
                ],
                exports: [
                    AbTestVersionDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbTestsModule, { declarations: [AbTestVersionDirective], exports: [AbTestVersionDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServerCrawlerDetectorService extends AbstractUserAgentCrawlerDetector {
    /**
     * @param {?} httpRequest
     */
    constructor(httpRequest) {
        super();
        this.httpRequest = httpRequest;
    }
    /**
     * @return {?}
     */
    getUserAgentString() {
        if (this.httpRequest) {
            const /** @type {?} */ useAgentHeader = this.httpRequest.headers['user-agent'];
            return Array.isArray(useAgentHeader) ? useAgentHeader[0] : useAgentHeader;
        }
        return '';
    }
}
ServerCrawlerDetectorService.ɵfac = function ServerCrawlerDetectorService_Factory(t) { return new (t || ServerCrawlerDetectorService)(ɵngcc0.ɵɵinject(REQUEST)); };
ServerCrawlerDetectorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServerCrawlerDetectorService, factory: ServerCrawlerDetectorService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ServerCrawlerDetectorService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [REQUEST,] },] },
];
/** @nocollapse */ ServerCrawlerDetectorService.ngInjectableDef = defineInjectable({ factory: function ServerCrawlerDetectorService_Factory() { return new ServerCrawlerDetectorService(inject(REQUEST)); }, token: ServerCrawlerDetectorService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerCrawlerDetectorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [REQUEST]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ServerCookieHandlerService {
    /**
     * @param {?} cookieService
     */
    constructor(cookieService) {
        this.cookieService = cookieService;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    get(name) {
        if (this.cookieService) {
            return this.cookieService.get(name);
        }
    }
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} domain
     * @param {?=} expires
     * @return {?}
     */
    set(name, value, domain, expires) {
        if (this.cookieService) {
            this.cookieService.put(name, value, {
                domain,
                expires: expires ? new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24) : undefined
            });
        }
    }
}
ServerCookieHandlerService.ɵfac = function ServerCookieHandlerService_Factory(t) { return new (t || ServerCookieHandlerService)(ɵngcc0.ɵɵinject(ɵngcc1.CookiesService, 8)); };
ServerCookieHandlerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ServerCookieHandlerService, factory: ServerCookieHandlerService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ServerCookieHandlerService.ctorParameters = () => [
    { type: CookiesService, decorators: [{ type: Optional },] },
];
/** @nocollapse */ ServerCookieHandlerService.ngInjectableDef = defineInjectable({ factory: function ServerCookieHandlerService_Factory() { return new ServerCookieHandlerService(inject(CookiesService$1, 8)); }, token: ServerCookieHandlerService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerCookieHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.CookiesService, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class AbTestsServerModule {
}
AbTestsServerModule.ɵfac = function AbTestsServerModule_Factory(t) { return new (t || AbTestsServerModule)(); };
AbTestsServerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AbTestsServerModule });
AbTestsServerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: CrawlerDetector,
            useClass: ServerCrawlerDetectorService
        },
        {
            provide: CookieHandler,
            useClass: ServerCookieHandlerService
        },
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbTestsServerModule, [{
        type: NgModule,
        args: [{
                providers: [
                    {
                        provide: CrawlerDetector,
                        useClass: ServerCrawlerDetectorService
                    },
                    {
                        provide: CookieHandler,
                        useClass: ServerCookieHandlerService
                    },
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { AbTestsModule, AbTestsServerModule, AbTestsService, CrawlerDetector, RandomExtractor, CookieHandler, CONFIG, AbstractUserAgentCrawlerDetector as ɵa, AbTestVersionDirective as ɵb, ServerCookieHandlerService as ɵd, ServerCrawlerDetectorService as ɵc };

